import PropTypes from 'prop-types';

import { status } from 'constants/general';
import Loader from 'modules/common/components/Loader';
import SearchBar from 'modules/common/components/SearchBar';
import UpdatePointsForm from 'modules/members/components/UpdatePointsForm';
import Modal from 'modules/common/components/Modal';
import membersStrings from 'modules/members/strings';

import MembersList from '../MembersList';
import { LoaderWrapper, MembersWrapper, AddMemberButton, AddIcon } from './MembersComponent.style';

const { addMembr } = membersStrings.membersComponent;

const MembersComponent = ({
  searchQuery,
  membersList,
  handleSearchBarInputChange,
  isAddMemberModalHidden,
  setIsAddMemberModalHidden,
}) => (
  <MembersWrapper>
    <SearchBar
      searchQuery={searchQuery}
      handleSearchBarInputChange={handleSearchBarInputChange}
      testId="membersSearch"
    />
    <AddMemberButton onClick={() => setIsAddMemberModalHidden(false)}>
      <AddIcon /> {addMembr}
    </AddMemberButton>

    {membersList?.status === status.FETCHING && (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    )}

    {membersList?.status === status.SUCCESS && (
      <MembersList searchQuery={searchQuery} membersList={membersList} />
    )}
    <Modal
      isModalHidden={isAddMemberModalHidden}
      onCloseModal={() => {
        setIsAddMemberModalHidden(true);
      }}
    >
      <UpdatePointsForm
        toAddNewMember
        toAddPoints
        closeModal={() => setIsAddMemberModalHidden(true)}
      />
    </Modal>
  </MembersWrapper>
);

MembersComponent.propTypes = {
  searchQuery: PropTypes.string,
  membersList: PropTypes.shape({
    details: PropTypes.shape({}),
    status: PropTypes.string,
  }).isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  isAddMemberModalHidden: PropTypes.bool.isRequired,
  setIsAddMemberModalHidden: PropTypes.func.isRequired,
};

MembersComponent.defaultProps = {
  searchQuery: '',
};

export default MembersComponent;
